// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"LoadingSpinner_Wrapper__3_GPU","Spinner":"LoadingSpinner_Spinner__CLtXN","rotate":"LoadingSpinner_rotate__2GbGp","Percentage":"LoadingSpinner_Percentage__1iHwQ"};